import { connect } from 'react-redux';

import { loadData } from '../redux/data';
import { retrieveProfile } from '../redux/profile';

import NewContact from '../components/NewContact/NewContact';

const mapStateToProps = ({ profile, auth }) => ({
  ...profile,
  ...auth
});

const mapDispatchToProps = dispatch => ({
  retrieveProfile: () => dispatch(retrieveProfile()),
  loadData: () => dispatch(loadData())
});

export default connect(mapStateToProps, mapDispatchToProps)(NewContact);



// WEBPACK FOOTER //
// ./src/containers/NewContact.js